import {
  VACANCY_CANDIDATE_VISIBILITY,
  VACANCY_SELECTION_METHOD,
} from "../../../../models/vacancy";
import { TVacancy } from "../../../../store/vacancy/types";
import People from "../../../UI/Icons/People";
import Time from "../../../UI/Icons/Time";

const JobShareDetails = ({
  selectedVacancyDetails,
  selectedTimeFrame,
  allSelectedTimeFrame,
}: {
  selectedVacancyDetails: TVacancy | null;
  selectedTimeFrame:
    | {
        label: string;
        value: number;
      }
    | undefined;
  allSelectedTimeFrame:
    | {
        label: string;
        value: number;
      }
    | undefined;
}) => {
  const {
    selection_method,
    visibility_type,
    response_timeframe,
    visibility_upgraded,
    status
  } = selectedVacancyDetails || {};
  const selectionMethod =
    selection_method === VACANCY_SELECTION_METHOD.FIRST_COME_FIRST_SERVED
      ? "First To Accept"
      : "I Choose the Candidate";

  const getVisibilityText = () => {
    let initial = "";
    let updateNote = "";

    switch (visibility_type) {
      case VACANCY_CANDIDATE_VISIBILITY.ANY_CANDIDATE:
        return "Publicly With All Candidates";

      case VACANCY_CANDIDATE_VISIBILITY.PREFERRED_CANDIDATES:
        initial = "With Preferred Candidates Only";
        if (visibility_upgraded) {
          updateNote =
            ". No response received in time, now shared with all other candidates.";
        }
        break;

      case VACANCY_CANDIDATE_VISIBILITY.SELECTED_CANDIDATE:
        if (visibility_upgraded === VACANCY_CANDIDATE_VISIBILITY.ANY_CANDIDATE) {
          return "Publicly With All Candidates";
        }
        initial = "With One Selected Candidate Only";
        if (visibility_upgraded === VACANCY_CANDIDATE_VISIBILITY.PREFERRED_CANDIDATES) {
          updateNote =
            ". No response received in time, now shared with preferred candidates.";
        }
        break;

      default:
        return "With All Candidates";
    }

    return `${initial}${updateNote}`;
  };

  const isPreferredFallbackActive =
    !!response_timeframe &&
    visibility_upgraded === null &&
    (visibility_type === VACANCY_CANDIDATE_VISIBILITY.SELECTED_CANDIDATE ||
      visibility_type === VACANCY_CANDIDATE_VISIBILITY.PREFERRED_CANDIDATES);

  const isAllCandidatesFallbackActive =
    !!selectedVacancyDetails?.all_response_timeframe_check &&
    visibility_type === VACANCY_CANDIDATE_VISIBILITY.SELECTED_CANDIDATE &&
    visibility_upgraded !== VACANCY_CANDIDATE_VISIBILITY.ANY_CANDIDATE;

  const renderPreferredFallbackNotice = () => {
    if (!isPreferredFallbackActive) return null;
    const fallbackTarget =
      visibility_type === VACANCY_CANDIDATE_VISIBILITY.PREFERRED_CANDIDATES
        ? "other"
        : "preferred";

    return (
      <div className="d-flex gap-10 align-items-center">
        <Time />
        <div className="fs-16 fw-400 text-black">
          If there {visibility_type === VACANCY_CANDIDATE_VISIBILITY.SELECTED_CANDIDATE ? "is" : "are"} no {visibility_type === VACANCY_CANDIDATE_VISIBILITY.SELECTED_CANDIDATE ? "response" : "responses"} within{" "}
          <span className="fw-700">
            {selectedTimeFrame?.label}
          </span>{" "}
          of the time of posting,
          <br />
          this vacancy will be shared with all {fallbackTarget} candidates.
          {!isAllCandidatesFallbackActive && (
            <>
              <br />
              <span className="text-grey-light">
                Chosen Candidate: {selectionMethod}
              </span>
            </>
          )}
        </div>
      </div>
    );
  };

  const renderAllCandidatesFallbackNotice = () => {
    if (!isAllCandidatesFallbackActive) return null;

    return (
      <div className="d-flex gap-10 align-items-center">
        <Time />
        <div className="fs-16 fw-400 text-black">
          <>
            If there {visibility_type === VACANCY_CANDIDATE_VISIBILITY.SELECTED_CANDIDATE ? "is" : "are"} no {visibility_type === VACANCY_CANDIDATE_VISIBILITY.SELECTED_CANDIDATE ? "response" : "responses"} within{" "}
            <span className="fw-700">
              {allSelectedTimeFrame?.label}
            </span>{" "}
            of the time of posting,
            <br />
            this vacancy will be shared with all other candidates.
            <br />
            <span className="text-grey-light">
              Chosen Candidate: {selectionMethod}
            </span>
          </>
        </div>
      </div>
    );
  };

  const isCandidateAvailable = selectedVacancyDetails?.selected_candidate?.candidate_available;
  const preferredFallbackNotice = renderPreferredFallbackNotice();
  const allCandidatesFallbackNotice = renderAllCandidatesFallbackNotice();

  return (
    <>
      <div className="d-flex gap-10 align-items-center justify-content-center">
        <People />
        <div className="fs-16 fw-400 text-black text-center">
          Job Shared {getVisibilityText()}
          {
            isCandidateAvailable !== true && isCandidateAvailable !== undefined && (
              <div className="text-grey-medium fs-13">
                This vacancy has been filled by Connected Crew admin. <br />
                For further changes please contact them directly.
              </div>   
            )
          } 
        </div>
        <br />    
        
      </div>
      {status === "active" && (preferredFallbackNotice || allCandidatesFallbackNotice) && (
        <div className="d-flex flex-column align-items-center mt-10 gap-10">
          <div className="d-flex flex-column align-items-start gap-30">
            {preferredFallbackNotice}
            {allCandidatesFallbackNotice}
          </div>
        </div>
      )}
    </>
  );
};

export default JobShareDetails;
